import { Heading, RecordContent, RecordFooter, useTitleChange } from '@msaf/core-react'
import { useState } from 'react'
import { AquiferTestSummaryTable } from '../../../../components/well-forms/aquifer-test/summary-table'
import WellViewButtons from '../../../../components/wells/well-view-buttons'
import { useWellId } from '../../../../hooks/use-well-id'

export default function ViewWellAquiferTests() {
  useTitleChange('View Well | Aquifer tests')
  const wellId = useWellId()
  // Form fields
  const [fields, setFields] = useState<Array<Record<string, string | number | boolean>> | null>(null)
  return (
    <>
      <RecordContent>
        <Heading level={2}>Aquifer tests</Heading>
        <AquiferTestSummaryTable fields={fields} setFields={setFields} isViewMode />
      </RecordContent>
      <RecordFooter>
        <WellViewButtons wellId={wellId} />
      </RecordFooter>
    </>
  )
}
